"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// removed fields from PlascoTrac
//  proxy: string
// rfidiClass string;
// studentScheduele2es: IRelationId[];
